var map = {
	"./info-sharing-center-de.html": 941,
	"./info-sharing-center-en.html": 942,
	"./info-sharing-center-es.html": 943,
	"./info-sharing-center-fr.html": 944,
	"./info-sharing-center-ja.html": 945,
	"./info-sharing-center-pt.html": 946,
	"./info-sharing-center-zh.html": 947
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 940;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 940
// module chunks = 0